"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("dayjs/locale/nl");
var dayjs_1 = __importDefault(require("dayjs"));
dayjs_1.default.locale('nl');
